/* eslint-disable */
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import helpers from '../../Support/DateManipulation';
import DateRangeSelectorPropTypes from './DateRangeSelector.component.props';

/**
 * DateRangeSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DateRangeSelector = ({ onChange = () => {}, isCustom, label }) => {
  const [selectedRange, setRange] = useState(`yesterday`);
  useEffect(() => {
    onChange(helpers.getYesterday());
  }, []);

  return (
    <FormControl fullWidth>
      {label && (
        <InputLabel htmlFor="dateRange" shrink>
          {label}
        </InputLabel>
      )}
      <Select
        id="dateRange"
        onChange={(event) => {
          const { value: selectedValue } = event.target || {};
          setRange(selectedValue);
          if (onChange) {
            switch (selectedValue) {
              case `thisWeek`:
                return onChange(helpers.getThisWeek());
              case `thisMonth`:
                return onChange(helpers.getThisMonth());
              case `thisQuarter`:
                return onChange(helpers.getThisQuarter());
              case `yesterday`:
                return onChange(helpers.getYesterday());
              case `previousWeek`:
                return onChange(helpers.getPreviousWeek());
              case `previousMonth`:
                return onChange(helpers.getPreviousMonth());
              case `lastTwoMonths`:
                return onChange(helpers.getLastTwoMonths());
              case `previousQuarter`:
                return onChange(helpers.getPreviousQuarter());
              default:
                return ``;
            }
          }
        }}
        value={isCustom ? `custom` : selectedRange}
      >
        <MenuItem key="yesterday" value="yesterday">
          Yesterday
        </MenuItem>
        <MenuItem key="thisWeek" value="thisWeek">
          This Week
        </MenuItem>
        <MenuItem key="thisMonth" value="thisMonth">
          This Month
        </MenuItem>
        <MenuItem key="previousWeek" value="previousWeek">
          Previous Week
        </MenuItem>
        <MenuItem key="previousMonth" value="previousMonth">
          Previous Month
        </MenuItem>
        <MenuItem key="lastTwoMonths" value="lastTwoMonths">
          Last Two Months (to-date)
        </MenuItem>
        <MenuItem key="custom" value="custom">
          Custom
        </MenuItem>
      </Select>
    </FormControl>
  );
};

DateRangeSelector.propTypes = DateRangeSelectorPropTypes;

export default DateRangeSelector;
